<app-nav-bar></app-nav-bar>
        <div class="tab"  role="tabpanel" aria-labelledby="pills-home-tab" >

            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" style="padding: 2% 17%;">
              <div class="row">
                <div class="col-md-6">
                  <h3 style="color:rgb(94, 90, 90);font: 500 20px/32px Roboto, Helvetica Neue, sans-serif;letter-spacing: normal;margin: 0 0 16px;">Scheduled Conference List</h3>
                  </div>
                  <!-- <div class="col-md-3">
                  </div> -->
                  <div class="col-md-6">
                      <button type="button" class="btn btn-danger btn-lg" (click)="toCreateConference()" style="width:251px; padding:10px 8px; font-size: 16px; font-weight: 500; line-height: 20px; border:none;margin-left: 100px;"><i class="fab fa-youtube" style="color: #fff;"></i> &nbsp; Create Conference </button>         
                      <!-- <button type="button" class="btn btn-danger btn-lg" style="width:220px; padding:10px 8px; font-size: 16px; font-weight: 500; line-height: 20px; margin-left: 10px; background-color: #004526; border:none"><i class="fab fa-youtube" style="color: #fff;"></i> &nbsp;Create Offline Webinar</button> -->
                    
                  </div>
                
              </div>
          
          
          
              
              <ul class="nav nav-pills2 mb-3" id="pills-tab" role="tablist">
          
                <li class="nav-item" >
                  <a class="nav-link2 active" id="my-webinar1" data-toggle="pill" href="#myWebinar1" role="tab" aria-controls="my-webinar1" aria-selected="true" style="border-radius: 0; text-align: center;font-size: 20px;">My Conference</a>
                </li>
                <li class="nav-item" >
                  <a class="nav-link2" id="hosted-by-me1" data-toggle="pill" href="#hostedByMe1" role="tab" aria-controls="hosted-by-me1" aria-selected="false" style="border-radius: 0;font-size: 20px;">Hosted by me</a>
                </li>
                
              </ul>
              
            <div class="tab-content" id="pills-tabContent">
          
              <!---My WebinarStart-->
                <div class="tab-pane fade show active" id="myWebinar1" role="tabpanel" aria-labelledby="my-webinar1">    
                <div class="row">
                  <div class="col-md-6" *ngFor="let list of hostInfo">         
                    <div style="width: 552px;height: 190px; border:1px solid #87b538; border-radius: 15px; box-shadow: 0px 0px 2px 0px #87b538;background-color: #fff;margin-bottom: 8px;">
                      <div class="row" style="margin-top: 18px;">
                        <div class="col-md-6">
                          <span style="padding: 0 14px;font-size: 18px;
                          font-weight: 400;">Topic</span>
                          <br><br>
                          <span style="padding: 0 14px;font-size: 18px;
                          font-weight: 550; color: #004526;">{{list.eventName}}</span>
                          <br>
                          <span style="padding: 0 14px;
                          font-weight: 400;"><b>{{list.startTime}}</b></span>
                        </div>
                        
            
                        <div class="col-md-6">
                          <span style="font-size: 18px;font-weight: 400;color: #3f3d3d;">
                          <img src="../../assets/images/camera.png" style="padding: 0 8px;">
                           Call </span>
                          <span style="font-size: 30px;font-weight: 100;color: #e2dddd;padding: 0 10px;">|</span>
                          <span style="padding: 0 20px;font-size: 18px;font-weight: 400;padding: 0;color: #06482A;">
                          <img src="../../assets/images/member.png">

                          
                          <span data-toggle="modal" data-target="#exampleModalLong" style="cursor: pointer;" (click)="getMembersList(list.webinarId)">
                            {{list.webinarAttendeesCount}} Members </span><span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="cursor: pointer;"><img src="../../assets/images/threedot.png" style="height: 25px;" >
                             
                             <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                               <br>
                               <button type="button" (click)="delete(component,list)" class="btn btn-danger" style="margin-left: 17px;padding: 0 40px;">Delete</button><br>
                               <button type="button" class="btn btn-dark" style="margin-left: 17px;padding: 0 40px;margin-top: 13px;margin-bottom: 13px;">Cancel</button>                             
                             </div>


                            </span>
                          </span>
                          
                        </div>
                      </div>
            
                      <div class="row">
                     
                        <div class="col-md-6">
                          <br>
                          <span style="padding: 0 14px;font-size: 15px;font-weight: 400;">
                            {{list.startDate}}-{{list.dayName}} | 
                          <!-- <span style="color: red;font-size: 14px;font-weight: 400;" *ngIf="list.dateDiff===0"> 
                            <countdown [config]="{leftTime: list.dateDiffSec}"></countdown>
                          </span>
                          <span style="color: red;font-size: 14px;font-weight: 400;" *ngIf="list.dateDiff > 0"> 
                            <countdown [config]="{leftTime: list.dateDiffSec}"> </countdown>
                          </span> -->
                          <span style="color: red;font-size: 14px;font-weight: 400;" > 
                            00.00.00
                          </span>
                        </span>
                        
                        </div>
                        <div class="col-md-6">
                          &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-success" style="width: 115px;margin-right: 10px;background-color: #fff;color: #004526; border: 2px solid; font-weight: 500; padding: 7px 4px;margin-top: 10px;">Rescheduled </button>
                        <span *ngIf="list.dateDiff===0">
                          <button class="btn btn-warning" style="width: 100px; background-color: #F7BC1D;color: white;font-weight: 500;padding: 8px 4px;margin-top: 10px;">Start </button>                       
                        </span>   
                        <span *ngIf="list.dateDiff > 0">
                          <button class="btn btn-warning" style="width: 100px; background-color: #F7BC1D;color: white;font-weight: 500;padding: 8px 4px;margin-top: 10px;">Start </button>                       
                        </span>   
                        <span *ngIf="list.dateDiff < 0">
                          <button class="btn btn-warning" style="width: 100px; background-color: #F7BC1D;color: white;font-weight: 500;padding: 8px 4px;margin-top: 10px;">Expired </button>                       
                        </span>    
                         
                        </div>        
                      </div>
                    </div>
          
                  </div>
          
                </div>
            
            
                
              </div>
            
            
                 
            
              <div class="tab-pane fade" id="hostedByMe1" role="tabpanel" aria-labelledby="hosted-by-me1">  
                <div class="row">
                  <!-- <h2>HostedBy</h2> -->
                  <div class="col-md-6" *ngFor="let list of attendInfo">
                    <div style="width: 552px;height: 190px; border:1px solid #87b538; border-radius: 15px; box-shadow: 0px 0px 2px 0px #87b538;background-color: #fff;margin-bottom: 8px;">
                      <div class="row" style="margin-top: 18px;">
                        <div class="col-md-6">
                          <span style="padding: 0 14px;font-size: 18px;
                          font-weight: 400;">Topic</span>
                          <br><br>
                          <span style="padding: 0 14px;font-size: 18px;
                          font-weight: 550; color: #004526;">{{list.eventName}}</span>
                          <br>
                          <span style="padding: 0 14px;
                          font-weight: 400;"><b>{{list.startTime}}</b></span>
                        </div>
            
                        <div class="col-md-6">
                          <span style="font-size: 18px;font-weight: 400;color: #3f3d3d;">
                          <img src="../../assets/images/camera.png" style="padding: 0 8px;">
                           Call </span>
                          <span style="font-size: 30px;font-weight: 100;color: #e2dddd;padding: 0 10px;">|</span>
                          <span style="padding: 0 20px;font-size: 18px;font-weight: 400;padding: 0;color: #06482A;">
                          <img src="../../assets/images/member.png">  
                          <span data-toggle="modal" data-target="#exampleModalLong" style="cursor: pointer;" >             
                            {{list.webinarAttendeesCount}} Members </span><img src="../../assets/images/threedot.png" style="height: 25px;" ></span>
                        </div>
                      </div>
            
                      <div class="row">
                   
                        <div class="col-md-6">
                          <br>
                          <span style="padding: 0 14px;font-size: 15px;font-weight: 400;">
                            {{list.startDate}}-{{list.dayName}} | 
                            <!-- <span style="color: red;font-size: 14px;font-weight: 400;" *ngIf="list.dateDiff===0"> 
                              <countdown [config]="{leftTime: list.dateDiffSec}"></countdown> 
                            </span>
                            <span style="color: red;font-size: 14px;font-weight: 400;" *ngIf="list.dateDiff > 0"> 
                              <countdown [config]="{leftTime: list.dateDiffSec}"> </countdown>
                            </span> -->
                            <span style="color: red;font-size: 14px;font-weight: 400;"> 
                              00.00.00
                            </span>
                          </span>
                        
                        </div>
                        <div class="col-md-6">
                          &nbsp;&nbsp;&nbsp;
                          <button class="btn btn-success" style="width: 115px;margin-right: 10px;background-color: #fff;color: #004526; border: 2px solid; font-weight: 500; padding: 7px 4px;margin-top: 10px;">Rescheduled </button>
                        
                          <span *ngIf="list.dateDiff===0">
                            <button class="btn btn-warning" style="width: 100px; background-color: #F7BC1D;color: white;font-weight: 500;padding: 8px 4px;margin-top: 10px;">Start </button>                       
                          </span>   
                          <span *ngIf="list.dateDiff > 0">
                            <button class="btn btn-warning" style="width: 100px; background-color: #F7BC1D;color: white;font-weight: 500;padding: 8px 4px;margin-top: 10px;">Start </button>                       
                          </span>   
                          <span *ngIf="list.dateDiff < 0">
                            <button class="btn btn-warning" style="width: 100px; background-color: #F7BC1D;color: white;font-weight: 500;padding: 8px 4px;margin-top: 10px;">Expired </button>                       
                          </span> 
          
                        </div>        
                      </div>
                    </div>
                  </div>
            
                  </div>
                  </div>
          
                </div>
            
            </div>

            <!-----Start Member List popup-->
        
     <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle" style="font-weight: 500;font-size: 25px;">Members Name</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container ScrollStyle" *ngFor="let list of webinarMembersList">
              <!-- <i class="fa fa-close" style="margin-left: 445px;color:red"></i> -->
              <p><span><img src="../../assets/images/Layer7.png" alt="Avatar" style="width:40px">
               {{list.name}}  <i class="fa fa-close" style="float: right;;color:red"></i></span></p>
              <!-- <p>John Doe saved us from a web disaster.</p> -->
              <!-- <span class="glyphicon glyphicon-remove" style="color: red;"></span> -->
              
              
            </div>
    
           <!-- <div class="wrapper" style="text-align:center" *ngFor="let list of webinarMembersList">
            <div class="item">
              {{list.name}}
            </div>
          <br>
          </div> -->
    
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>

  <!-----End Member List popup-->

          <!----Show Delete Popup-->
           <ng-template #component let-c="close" let-d="dismiss">
             <div class="modal-header">
                 <h4 class="modal-title">Alert Messages!!</h4>
             </div>
             <div class="modal-body">
                 <p>Do you want to delete this Webinar?&hellip;</p>
             </div>
             <div class="modal-footer">
                 <button type="button" class="btn btn-success" (click)="onDeleteMeeting()">Ok</button>
                 <button type="button" class="btn btn-secondary" (click)="c('Close click')">Cancel</button>
             </div>
           </ng-template>
          <!---End Delete Poup-->
        
</div>